/**
 * Copyright 2015-present Singlepoint. All Rights Reserved.
 *
 * @flow
 */

import './LoadUserRoute.scss';

import React, { useContext } from 'react';
import { Route } from 'react-router-dom';

import { CognitoContext } from '../../CognitoUtils';
import type { RouterPropsType } from '../../types/commonTypes';
import AnimatedSpinner from '../AnimatedSpinner/AnimatedSpinner';

const LoadUserRoute = ({ component: Component, ...rest }: any) => {
  const className = 'c-LoadUserRoute';
  const { loadingUser } = useContext(CognitoContext);

  return (
    <Route
      {...rest}
      render={(props: RouterPropsType) => {
        if (loadingUser) {
          return <div className={`${className}__spinnerContainer`}>
            <AnimatedSpinner size="large"></AnimatedSpinner>
          </div>
        }
        return <Component {...props} />;
      }}
    />
  );
};

export default LoadUserRoute;
